import * as $gzPerf from './perf.service';

export default angular.module('gazelle.components.perf', [
  'ui.router',
])
  .factory($gzPerf.name, $gzPerf.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/perf/perf.module.js